// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
} from '@/util/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('My List', null, 'list', '나의 회의'),
      route('Calendar', null, 'calendar', '회의실 예약 현황'),
      route('Reservation', null, 'reservation', '회의실 예약 정보'),
      route('ApproveReject', null, 'approveMgt', '예약 승인 관리'),
      route('Help Desk', null, 'help', '회의실 예약 문의'),

      route('Dashboard', null, 'dashboard', '대시보드'),
      route('AdminAnalytics', null, 'analytics', '통계'),
      route('AdminRoom', null, 'manageRoom', '회의실 관리'),
      route('AdminNotice', null, 'manageNotice', '공지사항 관리'),
      route('AdminAuth', null, 'manageAuth', '권한 관리'),
      route('AdminSettings', null, 'settings', '시스템 관리'),
      route('AdminLogs', null, 'logs', '로그'),

      // Pages
      route('User Profile', null, 'components/profile'),

      // Login
      route('Login'),

      // SSo Login
      route('SSOLogin', null, 'sso/:hashEmail'),

      // 회원가입
      route('ComeIn', null, 'comeIn'),
    ]),
  ],
})

router.beforeEach((to, from, next) => {
  // console.log('to : ' + JSON.stringify(to.path) + ' / from : ' + JSON.stringify(from))
  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
